<template>
  <div>
    <div class="site-main" v-if="isReady">
      <!-- nav部分 -->
      <div class="banner">
        <!-- 轮播图部分 -->
        <pic-swipe :items="items"></pic-swipe>
      </div>

      <!-- banner-info部分 -->
      <div class="columns bannerInfo is-mobile">
        <div class="column is-half-mobile is-half-tablet is-one-quarter-desktop">
          <a href="https://mp.weixin.qq.com/s?__biz=MzU1NDA4NjU2MA==&mid=2247486710&idx=4&sn=f909fe34e7c23e9f969412129db89229&chksm=fbe9b539cc9e3c2f4a1557ac1c8b360c4ff8fcbe00cfa7feece36f53bddb4fe005fff1372ba4#rd" target="_blank">
            <div class="media">
              <img src="../assets/bannerInfo/tencent@3x.png">
              <p>
                <strong>AI前线</strong>
                <span>紧跟前沿的AI技术社群</span>
              </p>
            </div>
          </a>
        </div>
        <div class="column is-half-mobile is-half-tablet is-one-quarter-desktop">
          <a href="http://www.infoq.com/cn/minibooks/architect-201707" target="_blank">
            <div class="media">
              <img src="../assets/bannerInfo/tech@3x.png">
              <p>
                <strong>《架构师》</strong>
                <span>一本属于架构师的电子杂志</span>
              </p>
            </div>
          </a>
        </div>
        <div class="column is-half-mobile is-half-tablet is-one-quarter-desktop">
          <a href="https://h5.youzan.com/v2/showcase/homepage?kdt_id=18601096&reft=1500973516574_1500973570771&spm=f46413509" target="_blank">
            <div class="media">
              <img src="../assets/bannerInfo/geekroom@3x.png">
              <p>
                <strong>极客官舍</strong>
                <span>为极致和美好付费</span>
              </p>
            </div>
          </a>
        </div>
        <div class="column is-half-mobile is-half-tablet is-one-quarter-desktop">
          <a href="/events" target="_blank">
            <div class="media">
              <img src="../assets/bannerInfo/dream@3x.png">
              <p>
                <strong>活动大本营</strong>
                <span>一周精彩技术活动</span>
              </p>
            </div>
          </a>
        </div>
      </div>

      <!-- conference部分 -->
      <div class="conference">
        <div class="container">
          <div class="title">
            <h1>大会</h1>
          </div>
          <ul class="columns">
            <!--  <li> -->
            <template v-if="!isMobile">
              <!-- <a :href="obj.urllink" target="_blank" v-for="(obj,index) in ConfNum1" :key="index" class="column is-two-thirds-tablet is-half-desktop first-conf"> -->
              <li v-for="(obj,index) in ConfNum1" :key="index" class="column is-two-thirds-tablet is-half-desktop first-conf">
                <div class="hover-a" :class="{'transparent':!displayHover}">
                  <div class="shadow" @click="location(obj.urllink)" :class="{'shadowCursor':!displayHover}">
                    <div class="content-a" v-if="displayHover">
                      <a class="left" :href="obj.urllink" target="_blank">
                        <p class="geekbang-icon">&#xe606;</p>
                        <p>查看大会</p>
                      </a>
                      <!-- <a class="right" href="#" @click="displayVideo(obj.videoUrl)"> -->
                      <!-- <a class="right" href="#" @click="displayVideo(obj.videoUrl)">
                        <p class="geekbang-icon">&#xe607;</p>
                        <p>观看视频</p>
                      </a> -->
                      <a class="right" href="//live.geekbang.org/room/btree" target="_blank">
                        <p class="geekbang-icon">&#xe607;</p>
                        <p>观看直播</p>
                      </a>
                    </div>
                  </div>
                </div>
              </li>
              <!-- </a> -->
            </template>
            <!-- </li> -->
            <template v-else>
              <li v-for="(obj,index) in ConfNum1" :key="index" class="column is-two-thirds-tablet is-half-desktop">
                <a :href="obj.urllink" target="_blank">
                  <div class="img">
                    <img :src="obj.m_imgUrl">
                  </div>
                  <div class="hover-a">
                    <div class="content-a" v-if="displayHover">
                      <a class="left" :href="obj.urllink" target="_blank">
                        <p class="geekbang-icon">&#xe606;</p>
                        <p>查看大会</p>
                      </a>
                      <!-- <a class="right" href="#" @click="displayVideo(obj.videoUrl)"> -->
                      <a class="right" href="//live.geekbang.org" target="_blank">
                        <p class="geekbang-icon">&#xe607;</p>
                        <p>观看视频</p>
                      </a>
                    </div>
                  </div>
                </a>
              </li>
            </template>
            <li v-for="(obj,index) in filterConf" :key="index" class="column is-one-third-tablet is-one-quarter-desktop">
              <a :href="obj.urllink" target="_blank">
                <!-- <img :src="obj.imgUrl"> -->
                <div class="img">
                  <img :src="obj.imgUrl" ref="m_confImg">
                </div>
                <div class="content">
                  <strong>{{obj.title}}</strong>
                  <span>{{obj.dateAndLoc}}</span>
                </div>
              </a>
            </li>
          </ul>
        </div>
      </div>

      <!-- course部分 -->
      <!-- <div class="course">
        <div class="container">
          <div class="title">
            <h1>课程</h1>
            <h3>
              <a href="http://new.stuq.org/course/explore" target="_blank">查看更多></a>
            </h3>
          </div>
          <ul class="columns">
            <template v-if="!isMobile">
              <li v-for="(item,index) in courses" :key="index" class="column is-half-tablet is-half-desktop">
                <a :href="item.urllink" target="_blank">
                  <div class="course-img">
                    <img :src="item.pc_imgUrl">
                  </div>
                  <div class="content">
                    <strong>{{item.title}}</strong>
                    <span class="course-profile">{{item.profile}}</span>
                    <span class="bottom">{{item.dateAndLoc}}</span>
                  </div>
                </a>
              </li>
            </template>
            <template v-else>
              <li v-for="(item,index) in filterCourseinMobile" :key="index" class="column is-half-tablet is-half-desktop">
                <a :href="item.urllink" target="_blank">
                  <div class="course-img">
                    <img :src="item.m_imgUrl">
                  </div>
                  <div class="content">
                    <strong>{{item.title}}</strong>
                    <span class="course-profile">{{item.profile}}</span>
                    <span class="bottom">{{item.dateAndLoc}}</span>
                  </div>
                </a>
              </li>
            </template>
          </ul>
        </div>
      </div> -->

      <!-- 专栏部分 -->
      <card-columns></card-columns>

      <!-- member部分 -->
      <div class="member">
        <div class="container">
          <div class="title">
            <h1>会员</h1>
            <h3>
              <a href="http://ego.geekbang.org/member" target="_blank">查看更多></a>
            </h3>
          </div>
          <div class="parentBox">
            <ul class="columns is-mobile childBox">
              <li v-for="(item,index) in members" :key="index" class="column is-one-third-tablet is-one-quarter-desktop">
                <!-- <a :href="item.urllink" target="_blank"> -->
                <a>
                  <div class="img">
                    <img :src="item.imgUrl">
                  </div>
                  <div class="content">
                    <p class="name">{{item.name}}</p>
                    <p class="company">{{item.company}}</p>
                    <div class="profile">{{item.profile}}</div>
                    <p class="brief">{{item.brief}}</p>
                  </div>
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <!-- video部分 -->
      <!-- pc端 -->
      <div class="video" v-if="!isMobile">
        <div class="container">
          <div class="title">
            <h1>视频</h1>
            <h3>
              <a href="https://live.geekbang.org/video" target="_blank">查看更多></a>
            </h3>
          </div>
          <ul class="columns">
            <li v-for="(item,index) in videos" :key="index" class="column is-half-tablet is-one-third-desktop">
              <a href="javascript:void(0)" @click="displayVideo(item.videoUrl)">
                <div class="video-img">
                  <img :src="item.imgUrl">
                  <div class="a"></div>
                </div>

                <p class="content">
                  <strong>{{item.title}}</strong>
                  <span>{{item.writer}}</span>
                </p>
              </a>
            </li>
          </ul>
        </div>
      </div>

      <!-- 移动端 -->
      <div class="video" v-if="isMobile">
        <div class="container">
          <div class="title">
            <h1>视频</h1>
          </div>
          <ul class="columns">
            <li v-for="(item,index) in videos" :key="index" class="column is-half-tablet is-one-third-desktop">
              <router-link :to="{name:'video',params:{id:item.id}}">
                <div class="video-img">
                  <img :src="item.imgUrl">
                  <div class="a"></div>
                </div>
                <p class="content">
                  <strong>{{item.title}}</strong>
                  <span>{{item.writer}}</span>
                </p>
              </router-link>
            </li>
          </ul>
        </div>
      </div>

      <!-- 弹出层 -->
      <modal :isShow="isShowVideo" :videolink="videoUrl" @closeModal="toclose"></modal>

    </div>
    <com-loader v-else></com-loader>
  </div>
</template>

<script>
import IScroll from 'iscroll'
import myBus from './vueBus.js'
import cardColumns from './cardColumns'
import comLoader from './com-loader'

// 引入数据
import conference from '../util/conference.js'
import courses from '../util/course.js'
import videos from '../util/video.js'
import members from '../util/member.js'
import picSwipe from '@/components/picSwipe'
import util from '@/util/WXshare'

export default {
  data () {
    return {
      isShowVideo: false,
      videoUrl: '',
      scrollTop: 0,
      scrollTop0: true,
      isMobile: true,
      isTablet: false,
      members: [],
      displayHover: false,
      isReady: false,
      ...conference,
      ...courses,
      ...videos,
      ...members
    }
  },
  components: {
    picSwipe,
    cardColumns,
    comLoader
  },
  created () {
    // 待所有内容准备好后再显示
    window.onload = () => {
      this.isReady = true
      this.$nextTick(() => {
        // 初始化设备信息
        this.initWidth()
        let banner = document.querySelector('.banner')
        if (!this.isMobile) {
          banner.style.height = '40.76vw'
        } else {
          banner.style.height = '93.066vw'
        }
        this.iscrollLeft()
      })
    }
    // console.log(this.videos)
    // 设备信息通信
    myBus.$on('changeDevice', (value) => {
      this.isMobile = value
    })
  },
  methods: {
    // 弹出模态框
    displayVideo (url) {
      this.isShowVideo = true
      this.videoUrl = url
    },
    // 关闭模态框
    toclose () {
      this.isShowVideo = false
      // 清空video的src属性
      this.videoUrl = ''
    },
    // 移动部分
    // 移动端横滑
    iscrollLeft () {
      return new IScroll('.parentBox', {
        scrollX: true,
        scrollY: false,
        // scrollbars: true,  // 滚动槽
        eventPassthrough: true
      })
    },
    location (link) {
      window.location.href = link
    },
    // 初始化设备宽度
    initWidth () {
      let winWidth = 0
      if (window.innerWidth) {
        winWidth = window.innerWidth
      } else if ((document.body) && (document.body.clientWidth)) {
        winWidth = document.body.clientWidth
      }
      this.isMobile = winWidth < 768 ? true : false
    }
  },
  computed: {
    // 对大会数据的切割处理
    filterConf () {
      return this.conference.slice(1, 7)
    },
    ConfNum1 () {
      return this.conference.slice(0, 1)
    },

    // 对课程数据的切割处理
    filterCourseinMobile () {
      return this.courses.slice(0, 2)
    },
    items () {
      let arr = [{
        url: 'https://time.geekbang.org/',
        pc_img: 'https://static.geekbang.org/infoq/5a32482bbcd77.png?imageView2/0/',
        m_img: 'https://static.geekbang.org/infoq/5a324883e4ca1.png?imageView2/0/'
      }]
      return arr
    }
  },
  mounted () {
    // 相关事件的开启
    // console.log(this.$store.state)
    util.shareInWeixin({})
  },
  beforeDestroy () {
    myBus.$off('changeDevice')
  }
}
</script>

<style lang="sass">
@import "../style/variable"

.bannerInfo
  background-color: #fff
  margin-bottom: 0 !important
  flex-wrap: wrap
  .column
    height: 140px
    border-left: 1px solid #f5f5f5
    border-right: 1px solid #f5f5f5
    margin-left: -1px
    padding: 0
    background-color: #fff
    z-index: 5
    +prefix(transition,all 0.2s linear)
    a
     display: flex
     width: 100%
     height: 100%
     align-items: center
     justify-content: center
     .media
      display: flex
      align-items: center
      justify-content: center
      img
       margin-right: 10px
       width: 88px
       height: 68px
      p
       font-size: 14px
       color: #888
       strong
         display: block
         font-size: 16px
         color: #353535
         font-weight: 400

  +desktop
    .column:hover
      +prefix(transform,translateY(-10px))
    .column:hover strong
      color: $primary !important


  +mobile
    .column
      height: 120px
      a
       width: 100%
       height: 100%
       align-items: center
       justify-content: center
       .media
        display: initial
        text-align: center
        img
          width: initial
          height: initial
          width: 4rem
          margin-right: initial
        p
         strong
           margin-bottom: 4px
           font-weight: 400
         span
           display: none

    .column:nth-child(-n+2)
      border-bottom: 1px solid #f5f5f5
  +tablet-only
    .column:nth-child(-n+2)
      border-bottom: 1px solid #f5f5f5


.conference
  background-color: #f5f5f5
  padding: 1.5rem 0
  .container
    margin: 0 auto
    overflow: hidden
    padding: 1rem
    .title
      display: flex
      justify-content: space-between
      align-items: center
      h1
        font-size: 28px
    .columns
      flex-wrap: wrap
      margin-top: 0.4rem
      align-items: stretch
      li
        padding: 0.88rem
        a
          display: flex
          flex-direction: column
          align-items: center
          background-color: #fff
          box-shadow: 0px 4px 8px 0px rgba(7, 17, 27, 0.1)
          height: 100%
          +prefix(transition, .3s all linear)
          .img
           transition: all 0.8s
           width: 100%

           img
             width: 100%
             vertical-align: middle

          .img:hover
           opacity: 0.8
          .content
           display: flex
           flex-direction: column
           justify-content: center
           width: 100%
           padding: 1rem
           strong
            font-weight: 400
            font-size: 16px
            display: block

            +limit-line-numbers(1)
           strong:hover
            color: $primary
           span
            margin-top: 4px
            font-size: 14px
            color: #919191
            +limit-line-numbers(1)
        a:hover
          box-shadow: 0px 8px 16px 0px rgba(7, 17, 27, 0.2)
      .first-conf
       position: relative
       background-color: transparent
       background: url('https://static001.geekbang.org/resource/image/a0/99/a02a93bd911bf5623fac4b2bbcd0dc99.jpg') center center no-repeat
       background-size: cover
       background-clip: content-box
       transition: .3s all linear
       cursor: pointer
       padding: 0.88rem
       .hover-a
        position: absolute
        width: 100%
        height: 100%
        left: 0
        top: 0
        background-color: transparent
        transition: 0.3s all linear
        padding: 0.88rem
        background-clip: content-box
        .shadow
          width: 100%
          height: 100%
          box-shadow: 0px 4px 8px 0px rgba(7, 17, 27, 0.6)
          transition: 0.3s all linear
          display: flex
          align-items: center
          justify-content: center
        .shadowCursor
          cursor: pointer
          .content-a
            display: flex
            color: #fff
            justify-content: space-between
            width: 44%
            opacity: 0
            transition: 0.3s all linear
            .left
              display: block
              background-color: initial
              box-shadow: initial
              p:first-child
                font-size: 4rem
              p:last-child
                font-size: 1rem
              p:last-child:hover
                color: $primary
            .left:hover
              color: #fff
            .right
              display: block
              background-color: initial
              box-shadow: initial
              p:first-child
                font-size: 4rem
              p:last-child
                font-size: 1rem
              p:last-child:hover
                color: $primary
            .right:hover
              color: #fff
      .first-conf:hover
        .hover-a
          background-color: rgba(0,0,0,0.8)
        .hover-a.transparent
          background-color: transparent
          .shadow
            box-shadow: 0px 8px 16px 0px rgba(7, 17, 27, 0.6)
            .content-a
              opacity: 1
      +mobile
        .first-conf
          background: url(https://static001.geekbang.org/resource/image/98/3b/98bc3cca1fdf26e3dd211f835326a43b.jpg) center center no-repeat


    +tablet-only
      li
        a
         .content
          strong
            font-size: 16px !important
      li:nth-child(n+6)
        display: none

+mobile
 .conference
  .container
    .title
      h1
        font-size: 26px
      h3
        line-height: 40px
    .columns
      li
        padding: 0.7rem 0.88rem
        a
          position: relative
          .img
           img
             max-height: 443px
             vertical-align: middle
          .img:hover
          .content
           position: absolute
           bottom: 0
           background-image: linear-gradient(rgba(0,0,0,0),rgba(0,0,0,1))
           padding-bottom: 0.5rem
           padding-left: 0.7rem
           strong
            color: #fff
           strong:hover
            color: #fff
           span
          .hover-a
            position: absolute
            width: 100%
            height: 100%
            background-color: rgba(255,255,255,0)
            display: flex
            align-items: flex-end
            justify-content: center
            .content-a
              display: flex
              color: #fff
              width: 100%
              padding: 0.4rem 0.8rem
              // background-image: linear-gradient(transparent, black)
              background-color: rgba(9,16,44,0.6)
              .left
                flex-grow: 1
                display: flex
                justify-content: center
                flex-direction: row
                align-items: center
                background-color: initial
                box-shadow: initial
                p:first-child
                  font-size: 1.2rem
                  margin-right: 1rem
                p:last-child
                  font-size: 0.2rem
                  white-space: nowrap
                p:last-child:hover
                  color: $primary
              .left:hover
                color: #fff
              .right
                flex-grow: 1
                display: flex
                justify-content: center
                align-items: center
                flex-direction: row
                background-color: initial
                box-shadow: initial
                p:first-child
                  font-size: 1.2rem
                  margin-right: 1rem
                p:last-child
                  font-size: 0.2rem
                  white-space: nowrap
                p:last-child:hover
                  color: $primary
              .right:hover
                color: #fff



      li:first-child
        a
          position: relative
          img


      li:nth-child(n+4)
        display: none



.course
  padding: 2rem 0
  .container
    margin: 0 auto
    overflow: hidden
    padding: 1rem
    .title
      display: flex
      justify-content: space-between
      align-items: flex-end
      h1
        font-size: 1.8rem
      h3
        font-size: 16px
        color: #888
    .columns
      margin-top: 0.4rem
      flex-wrap: wrap
      li.column
        background-color: #fff
        padding:  0.88rem
        a
         display: flex
         align-items: center
         box-shadow: 0px 0px 16px 3px rgba(7, 17, 27, 0.1)
         transition: .3s all linear
         .course-img
          vertical-align: top
          display: inline-block
          -webkit-transition: all .3s ease-in-out
          transition: all .3s ease-in-out
          width: 50%
          overflow: hidden
          img
            vertical-align: bottom
            transition: all 0.8s
            border: 1px solid #fff
            margin: -1px
         .course-img:hover
          opacity: 0.8

         .content
            width: 45%
            font-size: 14px
            line-height: 23px
            color: #888
            flex: 1
            padding-left: 1.6rem
            padding-right: 1.6rem
            strong
              display: block
              font-size: 16px
              margin-bottom: 15px
              color: #353535
              font-weight: 400
              text-align: justify

            strong:hover
              color: $primary
            .course-profile
              color: #888

              text-align: justify
              font-size: 14px
              +limit-line-numbers(3)
            span
              display: block
              margin-top: 10px
              color: #888
            span.bottom
              font-size: 14px


        a:hover
          box-shadow: 0px 4px 14px 2px rgba(7, 17, 27, 0.2)

+touch
  .course
    .container
      .title
        h1
        h3
      .columns
        li.column
          a
           flex-direction: column
           .course-img
            width: 100%
           .course-img:hover::after
           img
            width: 100%
           .content
              width: 100%
              padding-top: 1.5rem
              strong
               text-align: justify
              strong:hover
               color: initial
              span
+tablet-only
  .course
    li:nth-child(n+5)
      display: none
    .content
      padding-bottom: 1.5rem
      strong
        display: -webkit-box !important
        +limit-line-numbers(1)
+mobile

 .course
  .container
    .title
      align-items: center
      h1
      h3
    .columns
      li.column
        a
         box-shadow: initial
         .course-img
          img
         .course-img:hover
         .content
            padding: initial
            padding-top: 1rem
            padding-right: 1px
            strong
            strong:hover
            .course-profile
            span
            span.bottom
        a:hover
         box-shadow: initial
      li:first-child
        a
          .content
              padding-bottom: 1rem
              border-bottom: 1px solid #efefef
      li:nth-child(n+3)
        display: none



.member
  background-color: #f5f5f5
  padding: 2rem 0
  .container
    margin: 0 auto
    overflow: hidden
    position: relative
    padding: 1rem
    .title
      display: flex
      justify-content: space-between
      align-items: flex-end
      h1
        font-size: 1.8rem
      h3
        font-size: 16px
        color: #888
    .parentBox
      .iScrollLoneScrollbar
        width: 96vw
        bottom: 10px
      .columns
        flex-wrap: wrap
        margin-top: 0.4rem
        li.column
          border-radius: 5px
          padding: 0.88rem
          transition: .3s all linear
          width: 20%
          a
            cursor: default
            background-color: #fff
            display: flex
            align-items: center
            justify-content: center
            flex-direction: column
            width: 100%
            height: 100%
            padding: 0.9rem
            transition: all 0.3s
            box-shadow: 0px 4px 15px 0px rgba(7, 17, 27, 0.1)
            .img
              width: 61%
              margin: 20px 0 10px
              text-align: center
            .content
              text-align: center
              margin-bottom: 20px
              p.name
               font-weight: 700
               margin-bottom: 2%
              div
               font-size: 12px
               color: #888
              p.company
               font-size: 12px
               color: #888
              p.brief
                text-align: justify
                font-size: 12px
                color: #999
                margin-top: 5%
                +limit-line-numbers(3)
          a:hover
            // box-shadow: 0px 8px 16px 0px rgba(7, 17, 27, 0.2)




+tablet-only
  .member
    .container
      .title
      .parentBox
        .columns
          li.column
            width: 33.33%
          li:nth-child(n+7)
            display: none


+mobile
  .member
    .container
       .title
         align-items: center
       .parentBox
          height: 22rem
          .columns
            flex-wrap: nowrap
            width: 760%
            li.column
              a
                .img
                  img





.video
  padding: 2rem 0  5rem
  .container
    margin: 0 auto
    padding: 1rem
    .title
      display: flex
      justify-content: space-between
      align-items: center
      h1
        font-size: 1.8rem
      h3
        font-size: 16px
        color: #888
    .columns
      margin-top: 0.4rem
      flex-wrap: wrap
      li.column
        background-color: #fff
        a
          display: block
          width: 100%
          height: 100%

          .video-img
           position: relative
           img
            transition: all 0.8s
            width: 100%
            border: 1px solid #fff
           .a
            position: absolute
            left: 14px
            bottom: 14px
            background: url(../assets/whitevideo.png)
            background-size: 100%
            width: 73px
            height: 45px
          p
           margin-top: 10px
           font-size: 14px

           strong
             font-weight: 400
             font-size: 16px
             display: block
             +limit-line-numbers(1)
           span
             margin-top: 2px
             color: #999

        a:hover .a
         background: url(../assets/highvideo.png)
         background-size: 100%
        a:hover .video-img img
         opacity: 0.8

+tablet-only
 .video
  .container
   .columns

     li.column:nth-child(n+5)
       display: none

+mobile
 .video
  .container
   padding: 1rem
   .columns

     li.column:nth-child(n+4)
       display: none
       a:hover .a

// html[data-useragent*='MSIE 10.0']

_:-ms-fullscreen, :root .conference .img
  height: 100%
_:-ms-lang(x), .ie10 .conference .img
  height: auto


_:-ms-fullscreen, :root .member .img
  height: 100%
_:-ms-fullscreen, :root .member li
  height: 100%
_:-ms-fullscreen, :root .member a
  height: 100%

_:-ms-fullscreen, :root .member .content
  height: 100%
  width: 100%

_:-ms-fullscreen, :root .navbar .search
  align-items: flex-start !important
  margin-top: 5px !important

@media screen and (-ms-high-contrast: active) , (-ms-high-contrast: none)
  .member .content
    width: 100%
  .navbar .search
    align-items: flex-start !important
    margin-top: 5px !important

_:-ms-fullscreen, :root .modal-content
   top: 50%
   left: 50%
   transform: translate(-50%,-50%)
   position: fixed !important






</style>



// WEBPACK FOOTER //
// Home.vue?4b2122ec